import { toast as toastifyToast } from 'react-toastify';
import styles from './Toast.module.css';

function Msg({ title, text = '' }) {
  return (
    <div className={styles.msgContainer}>
      <p className={styles.msgTitle}>{title}</p>
      <p className={styles.msgText}>{text}</p>
    </div>
  );
}

const msgPropsToContent = (msgProps) => {
  const msg = { title: '', text: '' };
  if (typeof msgProps === 'string') {
    msg.title = msgProps;
  } else {
    msg.title = msgProps.title;
    msg.text = msgProps.text;
  }
  return msg;
};

const toast = (msgProps, toastProps) => {
  const msg = msgPropsToContent(msgProps);

  toastifyToast(<Msg {...msg} />, { ...toastProps });
};

export const toastUpdate = (toastId, msgProps, toastProps) => {
  const msg = msgPropsToContent(msgProps);

  if (toastifyToast.isActive(toastId)) {
    toastifyToast.update(toastId, { ...toastProps, render: <Msg {...msg} /> });
  } else {
    toastifyToast(<Msg {...msg} />, { ...toastProps, toastId });
  }
};

export default toast;
